// src/vocabulary/C1/unit3/content.js

const content = {
  level: "C1",
  unit: 3,
  title: "Technology & Its Impact",
  description:
    "Advanced vocabulary to discuss technology, digital life, and the impact of technology on individuals and society.",

  explanation: [
    "This unit focuses on how technology affects modern life.",
    "You will learn words used to discuss advantages and disadvantages of technology.",
    "These terms are common in debates, articles, and academic writing.",
    "At C1 level, learners should express balanced and critical views.",
    "For example: Technology increases efficiency, but it may reduce privacy.",
    "Many discussions focus on how technology changes communication and behavior.",
    "Using precise vocabulary helps you express complex opinions clearly.",
    "Try to discuss both positive and negative effects of technology."
  ],

  items: [
    {
      word: "digital dependence",
      phonetic: "/ˈdɪdʒɪtl dɪˈpendəns/",
      meaning: "an excessive reliance on digital devices and platforms that impairs autonomous functioning and critical engagement",
      example: "Digital dependence among younger generations has raised concerns among psychologists."
    },
    {
      word: "privacy",
      phonetic: "/ˈprɪvəsi/",
      meaning: "the individual's right to control access to their personal information and to be free from unsanctioned surveillance",
      example: "Online privacy is increasingly difficult to maintain in the age of data collection."
    },
    {
      word: "efficiency",
      phonetic: "/ɪˈfɪʃənsi/",
      meaning: "the capacity to accomplish objectives with minimal expenditure of time, energy, or resources relative to output",
      example: "Automation has significantly improved operational efficiency across many industries."
    },
    {
      word: "automation",
      phonetic: "/ˌɔːtəˈmeɪʃn/",
      meaning: "the deployment of technology to perform tasks with reduced human intervention, transforming labor markets and production processes",
      example: "Automation is displacing routine jobs while simultaneously creating demand for technical expertise."
    },
    {
      word: "innovation",
      phonetic: "/ˌɪnəˈveɪʃn/",
      meaning: "the deliberate introduction of novel ideas, methods, or products that generate substantial improvements or paradigm shifts",
      example: "Sustained innovation requires investment in both research and a culture of experimentation."
    },
    {
      word: "screen time",
      phonetic: "/ˈskriːn taɪm/",
      meaning: "the cumulative duration of engagement with digital screens, with implications for cognitive development and psychological well-being",
      example: "Excessive screen time has been correlated with reduced attention spans in adolescents."
    }
  ]
};

export default content;
